import { createCompositeTabsDomStructure } from "./dom-structure.js";
const createCompositeTabsElements = {
  DomStrcuture: createCompositeTabsDomStructure
};
export {
  createCompositeTabsElements
};
//# sourceMappingURL=index.js.map
